module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mlcPQl/tc-custom/9781459271517.jpg?1728954706452",
      "alt": "This image is the cover for the book Lucy and the Loner, The Family McCormick"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lucy and the Loner, The Family McCormick\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("MR. APRIL")]), _c('br'), _c('br'), _c('b', [_vm._v("THE MASTER (FOR A MONTH):")]), _vm._v(" Boone Cagney. When irresistible Lucy Dolan cried pitifully about her trapped three-year old, how was the hunky fire fighter to know she was talking about her"), _c('i', [_vm._v("cat?")]), _vm._v(" Now he's spending his daysand his nightswith both of them."), _c('br'), _c('br'), _c('b', [_vm._v("THE SLAVE (FOR A MONTH):")]), _vm._v(" Lucy Dolan. When Boone rescued Mack from the jaws of death, Lucy decided it was payback time."), _c('br'), _c('br'), _c('b', [_vm._v("THE DEBT:")]), _vm._v(" Lucy has to service Boone for thirty days only"), _c('i', [_vm._v("if")]), _vm._v(" he can bear to let her go at the end of them. After all, good help is so hard to find."), _c('br'), _c('br'), _c('b', [_vm._v("MAN OF THE MONTH:")]), _c('br'), _vm._v("He'd sworn to go it alone. So what was it about this womanand her ornery black felinethat had Boone thinking about the family plan?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth Bevarly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Elizabeth Bevarly is the award-winning, nationally number one bestselling author of more than seventy novels and novellas. Her books have been translated into two dozen languages and published in three dozen countries. An honors graduate of the University of Louisville, she has called home places as diverse as San Juan, Puerto Rico and Haddonfield, New Jersey, but now resides back in her native Kentucky with her husband, her son, and two neurotic cats (as if there were any other kind).")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0